import OrdersTable from "../../components/Orders/OrderTable";
import NavSettings from "../../components/common/NavSettings";

const Orders = () => {


  return (
    <>
      <NavSettings title="Mis Órdenes" route="Inicio" active="Mis Órdenes" />

      <OrdersTable />
    </>
  );
};

export default Orders;
